<header class="contrato-header no-print">
  <a routerLink="/" aria-label="Ir al inicio de Auri"><img src="assets/img/auri.png" alt="Auri Graduaciones"></a>
  <button class="btn fondoAmarillo blanco bold" type="button" (click)="imprimir()">Imprimir contrato</button>
</header>

<main class="contrato-container">
  <section class="openpay-clausula">
    <h2>Procesamiento de pagos electrónicos</h2>
    <p>Las transacciones serán efectuadas mediante la pasarela de Openpay.</p>
    <p>La autorización, rechazo y procesamiento de cada operación estarán sujetos a las validaciones de seguridad de Openpay y de la institución financiera correspondiente.</p>
  </section>
  <article class="contrato-texto" aria-label="Contrato de adhesión de Auri Graduaciones">{{contractText}}</article>
</main>
